import { toast } from "react-toastify";
import {
  storeStatesData,
  storeDistrictsData,
  hasError,
  startLoading,
  stopLoading,
  storeProducts,
  storeSeasons,
  storeLevelOne,
  storeLevelTwo,
  storeLevelThree,
} from "../redux/slices/filterSectionSlice.ts";
import { method, paths } from "../services/ServiceConstants.tsx";
import ServicesManagerAPICall from "../services/ServicesManagerAPICall.tsx";
import { handleAuthentication } from "../redux/slices/loginApiSlice.ts";
import { checkTokenMessage } from "./CountryAPI.tsx";

export const getStates = () => {
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.STATES_DATA,
        null,
        true,
        false
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(storeStatesData(res));
            }
          } else {
            toast("Unable to fetch states data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(storeStatesData([]));
          toast("Unable to fetch states data, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getDistricts = (sid: string) => {
  const data = {
    sid,
  };
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.DISTRICTS_DATA,
        data,
        true,
        true
      ).then(
        async (res: any) => {
          if (res != null) {
            if (checkTokenMessage(res)) {
              dispatch(handleAuthentication({}));
            } else {
              dispatch(storeDistrictsData(res));
            }
          } else {
            toast("Unable to fetch districts data, please try again later");
          }
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(storeDistrictsData([]));
          toast("Unable to fetch districts data, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

const storeResponse = (dispatch: any, res: any, label: string, setStorePayload: any, ) => {
  if (res != null) {
    if (checkTokenMessage(res)) {
      dispatch(handleAuthentication({}));
    } else {
      dispatch(setStorePayload(res));
    }
  } else {
    toast(`Unable to fetch ${label}, please try again later`);
  }
};
export const getProducts = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.PRODUCTS,
        null,
        true,
        false
      ).then(
        async (res: any) => {
          storeResponse(dispatch, res, 'product',storeProducts )
        },
        (err: any) => {
          toast("Unable to fetch product, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const getSeasons = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.SEASONS,
        null,
        true,
        false
      ).then(
        async (res: any) => {
          storeResponse(dispatch, res, 'season',storeSeasons )
        },
        (err: any) => {
          toast("Unable to fetch season, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const getLevelOne = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.LEVEL_ONE,
        null,
        true,
        false
      ).then(
        async (res: any) => {
          storeResponse(dispatch, res, 'level one',storeLevelOne )
        },
        (err: any) => {
          toast("Unable to fetch level one, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getLevelTwo = (params) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.LEVEL_TWO,
        params,
        true,
        false
      ).then(
        async (res: any) => {
          storeResponse(dispatch, res, 'level two', storeLevelTwo )
        },
        (err: any) => {
          toast("Unable to fetch level two, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getLevelThree = (sid) => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.LEVEL_THREE,
        {sid: sid},
        true,
        false
      ).then(
        async (res: any) => {
          storeResponse(dispatch, res, 'level three', storeLevelThree )
        },
        (err: any) => {
          toast("Unable to fetch level three, please try again later");
        }
      );
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};